export default __webpack_public_path__ + "static/media/1.d23c74e8.png";